import { render, staticRenderFns } from "./pjxq.vue?vue&type=template&id=7c03db78&scoped=true&"
import script from "./pjxq.vue?vue&type=script&lang=js&"
export * from "./pjxq.vue?vue&type=script&lang=js&"
import style0 from "./pjxq.vue?vue&type=style&index=0&id=7c03db78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c03db78",
  null
  
)

export default component.exports